import { emptySplitApi, TagTypes } from 'emptySplitApi'

import { Strategy, ArchivedStrategy, UpdateStrategy } from './types'

const strategyApi = emptySplitApi.injectEndpoints({
  endpoints: build => ({
    getStrategy: build.query<Strategy, void>({
      query: () => ({
        url: `strategy`,
      }),
      providesTags: [TagTypes.STRATEGY],
    }),
    checkIsNewStrategyDue: build.query<boolean, void>({
      query: () => ({
        url: 'strategy/due',
      }),
      providesTags: [TagTypes.STRATEGY_DUE],
    }),
    generateNewStrategy: build.mutation<Strategy, void>({
      query: () => ({
        url: 'strategy',
        method: 'POST',
      }),
      invalidatesTags: [TagTypes.STRATEGY, TagTypes.STRATEGY_DUE],
    }),
    updateStrategy: build.mutation<Strategy, UpdateStrategy>({
      query: ({ draftStep, committedAt, id, regenerateInitiatives }) => ({
        url: `strategy/${id}`,
        method: 'PATCH',

        body: { draftStep, committedAt, regenerateInitiatives },
      }),
      invalidatesTags: [TagTypes.STRATEGY, TagTypes.INITIATIVES],
    }),
    getArchivedStrategies: build.query<ArchivedStrategy[], void>({
      query: () => ({
        url: `strategy?archived=true`,
      }),
      providesTags: [TagTypes.STRATEGY],
    }),
  }),
})

export const {
  useGetStrategyQuery,
  useCheckIsNewStrategyDueQuery,
  useGenerateNewStrategyMutation,
  useGetArchivedStrategiesQuery,
  useUpdateStrategyMutation,
} = strategyApi
